/* eslint-disable array-callback-return */
import { CircularProgress, TableCell, TableRow } from '@material-ui/core';
import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setAppStateAction } from '../../../../actions/appStateAction';

import Calender from '../../../../components/Calender';
import { BaseURL } from '../../../../constants';

const TableHeadingRow = ({
  styles,
  showLoader,
  isdata,
  StocksColSpam,
  optionColSpam,
  setStateAction,
  state,
  accessLevel,
  loadUOAData,
  findCap,
}) => {
  const dispatch = useDispatch();
  const setAppState = (payload) => dispatch(setAppStateAction(payload));

  const fetchUOAbyDate = async (date) => {
    const newDate = moment().format('YYYY-MM-DD');
    setAppState({ selectedDate: date });
    if (newDate === date) {
      setAppState({ errorUoa: '' });
      return true;
    } else {
      try {
        const data = await axios.get(`${BaseURL}/api/get-uoa-by-date?date=${date}`);
        if (data.data.length <= 0) {
          setAppState({
            errorUoa: 'We Have no Data related to your search',
          });
          return data.data;
        } else {
          setAppState({ errorUoa: '' });

          return data.data;
        }
      } catch (error) {
        setAppState({
          errorUoa: 'Service Not Available Now',
        });
      }
    }
  };

  return (
    <TableRow style={{ height: '27px' }}>
      <TableCell
        colSpan={1}
        style={styles.calenderStyle}
        align="left"
        className="sticky"
      >
        <Calender
          key="UOA"
          getDate={async (e) => {
            setStateAction({ showLoader: true });
            setStateAction({ date: e });
            localStorage.setItem('Date', e);
            const data = await fetchUOAbyDate(e);

            if (data === true) {
              loadUOAData();
              setStateAction({
                showLoader: false,
              });
            } else {
              data &&
                data.length > 0 &&
                data.map((data) => {
                  data['mkt'] = findCap(
                    data['largecap'],
                    data['midcap'],
                    data['smallcap']
                  );
                });
              let newData;
              if (data && data.length) {
                newData = data.map((data) => {
                  return {
                    ...data,
                    earningObject: { date: data.earnings },
                    earningss: data.earnings,
                  };
                });
              }
              data && data.length <= 0
                ? setStateAction({
                  showLoader: false,
                  localUOA: newData,
                })
                : data &&
                setStateAction({
                  localUOA: newData,
                  showLoader: false,
                });
            }
          }}
          value={state.date}
          accessLevel={accessLevel}
        />
        <div style={{ paddingTop: '6px', paddingLeft: '6px' }}>
          {showLoader && isdata.length === 0 && (
            <CircularProgress size="1rem" color="white" />
          )}
        </div>
      </TableCell>
      <TableCell
        colSpan={StocksColSpam}
        style={styles.stockStyle}
        align="left"
        className="sticky"
      >
        Stocks
      </TableCell>
      <TableCell
        colSpan={optionColSpam}
        style={styles.optionStyle}
        align="left"
        className="sticky"
      >
        Options
      </TableCell>
    </TableRow>
  );
};
export default TableHeadingRow;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/tables/tableHeadingRow.jsx